import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios'
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

export class Products extends React.Component {

  state = {
    myProductData: []
  }

  componentWillMount() {
    this.fetchProductData();
  }

  deleteProduct = async (productId) => {
    axios.delete('/products/' + productId)
        .then(data => {
          this.fetchProductData();
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Product assigned to order, price list or catalogue. Cannot delete')
        })
  }

  fetchProductData = async () => {
    axios.get('/products')
        .then(data => {
          this.setState({
            myProductData: data
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to fetch products')
        })
  }

  cellButton(cell, row, enumObject, rowIndex) {
    return (
      <div>
        <Link to={'/products/edit/' + row.productID}><button type="button" className="btn btn-info btn-sm mar-right">Edit</button></Link>
        <button type="button" onClick={() => this.deleteProduct(row.productID)} className="btn btn-danger btn-sm">Delete</button>
      </div>
    )
  }

  stockFormatter(cell, row) {
    if (cell === 'true') {
      return '<span class="badge badge-success">Yes</span>'
    }
    else {
      return '<span class="badge badge-danger">No</span>'
    }
  }

  filterChange(evt) {
    this.refs.nameFilter.applyFilter(evt.target.value);
  }

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Products</h1>
            </div>
            <div className="row">
              <div className="col-sm-8 my-auto">
                {this.props.settings ? <Link to={'/products/new'}><button type="button" className="btn btn-success btn-sm mar-bot" disabled={this.props.settings.integration.type}>Add Product</button></Link>: null}
              </div>
              <div className="col-sm-4 my-auto">
                <div className="input-group mar-bot">
                  <div className="input-group-prepend">
                    <span className="input-group-text"><i className="fa fa-search"></i></span>
                  </div>
                  <input type="text" className="form-control" placeholder="Name..." onChange={this.filterChange.bind(this)}/>
                </div>
              </div>
            </div>
            <BootstrapTable data={this.state.myProductData} striped={true} hover={true} options={{defaultSortName: 'productID', defaultSortOrder: 'desc', sizePerPage: 50}} pagination>
              <TableHeaderColumn dataField="productID" isKey={true}>ID</TableHeaderColumn>
              <TableHeaderColumn dataField="productName" dataSort={true} ref='nameFilter' filter={ { type: 'TextFilter' } }>Name</TableHeaderColumn>
              <TableHeaderColumn dataField="categoryName" dataSort={true}>Category</TableHeaderColumn>
              <TableHeaderColumn dataField="stock" dataFormat={this.stockFormatter} dataSort={true}>Stock</TableHeaderColumn>
              <TableHeaderColumn dataField="price" dataSort={true}>Price</TableHeaderColumn>
              <TableHeaderColumn dataFormat={this.cellButton.bind(this)}>Action</TableHeaderColumn>
            </BootstrapTable>
          </div>
        );
    }
}
